import React, { useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormikDatePicker } from 'components/UiKit/FormikFields';
import { useFormikContext } from 'formik';
import sortDates from 'screens/Integrations/helpers/sortDates';
import { arrayObjectEquals } from 'helpers/arrayHelpers';

const CropSeasonDateRange = ({
  className = '',
  initialStartDate = /** @type {Date | null} */ (null),
  initialEndDate = /** @type {Date | null} */ (null),
  cropSeasons = /** @type {Array<object> | null} */ (null),
  isRequired,
  disabled = false
}) => {
  const { values, setFieldValue } = useFormikContext();
  const { startDate, endDate } = useMemo(() => {
    const { cropSeasonStartDate, cropSeasonEndDate } = sortDates(
      values.selectedCropSeasons
    );
    if (
      initialStartDate &&
      initialEndDate &&
      cropSeasons &&
      (initialStartDate !== cropSeasonStartDate ||
        initialEndDate !== cropSeasonEndDate) &&
      arrayObjectEquals(cropSeasons, values.selectedCropSeasons)
    ) {
      return {
        startDate: initialStartDate,
        endDate: initialEndDate
      };
    }
    return sortDates(values.selectedCropSeasons);
  }, [
    values.selectedCropSeasons,
    initialStartDate,
    initialEndDate,
    cropSeasons
  ]);

  useEffect(() => {
    setFieldValue('cropSeasonStartDate', startDate);
    setFieldValue('cropSeasonEndDate', endDate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate]);

  return (
    <div className={className}>
      <div className="min-w-0 flex-1">
        <FormikDatePicker
          label={isRequired ? 'Start Date *' : 'Start Date'}
          name="cropSeasonStartDate"
          placeholder=""
          allowClear={false}
          inputReadOnly
          disabled={disabled || !values?.selectedCropSeasons?.length}
        />
      </div>
      <div className="min-w-0 flex-1">
        <FormikDatePicker
          label={isRequired ? 'End Date *' : 'End Date'}
          name="cropSeasonEndDate"
          placeholder=""
          allowClear={false}
          inputReadOnly
          disabled={disabled || !values?.selectedCropSeasons?.length}
        />
      </div>
    </div>
  );
};

CropSeasonDateRange.propTypes = {
  className: PropTypes.string,
  initialStartDate: PropTypes.instanceOf(Date),
  initialEndDate: PropTypes.instanceOf(Date),
  cropSeasons: PropTypes.arrayOf(PropTypes.object),
  isRequired: PropTypes.bool.isRequired,
  disabled: PropTypes.bool
};

export default CropSeasonDateRange;
